export function getPublicPath(appName: string): string {
    const host = window.location.hostname;

    // in development mode, the devserver doesn't support relative paths (e.g. /portal_/admin/static/js/app.js)
    // so we need to set the publicPath to the root of the server
    let publicPath = process.env.NODE_ENV === 'development' ? '/' : '';

    switch (host) {
        case 'alpha.uipath.com':
            publicPath = `https://staticresources.uipath-dev.com/${appName}/${appName}/`;
            break;
        case 'alpha.gov.uipath-dev.com':
            publicPath = `https://staticresourcesalpha.gov.uipath-dev.com//${appName}/${appName}/`;
            break;
        case 'staging.uipath.com':
        case 'cloud.uipath.com':
            publicPath = `https://platform-cdn.uipath.com/${appName}/${appName}/`;
            break;
        case 'govcloud.uipath.us':
            publicPath = `https://staticresources.uipath.us/${appName}/${appName}/`;
            break;
    }

    return publicPath;
}
